module.exports = __webpack_public_path__ + "media/images/political-commitment-de202ac4dc6b1643ac5b14fd400c550e.jpg";